export enum FILE_PICKER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27770301
     */
    LAST_CREATED = 'WALL_ORDER_BY_CREATED',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454330
     */
    SELECT_FILE = 'WIDGET_TYPE_DRIVE-FILE-PREVIEW_SELECT_FILE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=664796597
     */
    SELECT_PDF = 'WIDGET_PDF_PREVIEW.SELECT_PDF',
}
